<template>
  <footer class="fr-footer">
    <div class="container">

      <div class="footer-links">
        <span>
					<a target="_blank" :href="localizedLink(legal.imprint_url)">{{ $t('dss.footer.imprint') }}</a>
				</span>
        <span class="line"> | </span>
        <span>
					<a target="_blank" :href="localizedLink(legal.terms_url)">{{ $t('dss.footer.terms') }}</a>
				</span>
        <span class="line"> | </span>
        <span>
          <a target="_blank" :href="localizedLink(legal.privacy_url)">{{ $t('dss.footer.privacy') }}</a>
        </span>
      </div>

      <div class="footer-address">
        <span class="address">{{ $t('dss.footer.legalEntity') }}</span>
      </div>

    </div>

  </footer>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import { localizedLink } from '@/lang';

export default defineComponent({
  name: "FrFooter",
  methods: { localizedLink },
  data() {
    return {
      legal: window.APP_CONFIG.legal
    }
  }
})
</script>

<style scoped>

</style>
